import { render, staticRenderFns } from "./ProfileAdd.vue?vue&type=template&id=95931b64&scoped=true&"
import script from "./ProfileAdd.vue?vue&type=script&lang=js&"
export * from "./ProfileAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAdd.vue?vue&type=style&index=0&id=95931b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95931b64",
  null
  
)

export default component.exports